'use client';

import { useTheme } from 'next-themes';
import { useEffect } from 'react';

interface ForcedThemeHandlerProps {
  theme?: string;
}

export function ForcedThemeHandler({ theme }: ForcedThemeHandlerProps) {
  const { setTheme } = useTheme();

  useEffect(() => {
    const normalizedTheme = theme?.toLowerCase();
    if (normalizedTheme === 'light' || normalizedTheme === 'dark' || normalizedTheme === 'system') {
      setTheme(normalizedTheme);
    }
  }, [theme, setTheme]);

  return null;
}
